module.exports = __webpack_public_path__ + "static/img/sicredi.c878a325.svg";